@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.header {
  display: flex;
  gap: 8px;
  align-items: center;
}

.headerText {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.suggestions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.suggestion {
  display: flex;
  gap: 20px;
  padding: 12px;
  align-items: center;
  border: 1px solid var(--border-soft);
  @include border-radius-r2;
  cursor: pointer;
  background: transparent;
  text-align: left;

  &:hover {
    border-color: transparent;
    background-image:
      linear-gradient(var(--background-default), var(--background-default)),
      linear-gradient(120deg,
        #3e63dd,
        #9eb1ff,
        #ffc53d,
        #ff92ad,
        #e93d82,
        #3e63dd,
        #9eb1ff,
        #ffc53d,
        #ff92ad,
        #e93d82,
        #3e63dd);
    background-clip: padding-box, border-box;
    background-size: 200% 100%;
    animation: gradientBorderMove 2s linear infinite;
  }
}

@keyframes gradientBorderMove {
  0% {
    background-position: 0% 50%;
  }

  100% {
    background-position: 100% 50%;
  }
}

.suggestionText {
  @include typography-v2-body-sm;
  color: var(--text-default);
  flex: 1;
  min-width: 0;
}

.sendButton {
  flex-shrink: 0;
}

.viewButton {
  flex-shrink: 0;
  white-space: nowrap;
}